import React from "react"
export function NoImage(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M17.943 1L19 2.06l-.956.954v-.002l-13.71 13.71h-.002L2.054 19 1 17.946 3.246 15.7l.001-12.454h12.45L17.943 1zm-1.216 5.444l.002 10.279H6.445l3.546-3.546 1.308 1.306 3.932-3.93-.002-2.612 1.498-1.497zm-2.528-1.7H4.745L4.744 14.2l9.455-9.457zM7.491 5.99a1.498 1.498 0 11.001 2.996 1.498 1.498 0 010-2.996z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__no-image"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
